/** TR translations for Les Aiguilles Blanches */
const tr: Record<string, string> = {
  subtitle: "Pist Bakım Simülatörü",
  startGame: "Oyuna Başla",
  resumeGame: "Devam Et",
  newGame: "Yeni Oyun",
  // UNUSED continue: "Devam",
  settings: "Ayarlar",
  controls: "Kontroller",
  changelog: "Yenilikler",
  howToPlay: "Nasıl Oynanır",
  fullscreen: "Tam Ekran",
  fullscreenHint: "Tam ekran için F'ye bas",
  exitFullscreen: "Tam Ekrandan Çık",
  back: "Geri",
  backToGame: "Oyuna Dön",
  // UNUSED loading: "Yükleniyor...",
  inputKeyboard: "✓ Klavye algılandı",
  inputKeyboardOff: "✗ Klavye yok",
  inputTouch: "✓ Dokunmatik ekran algılandı",
  inputTouchOff: "✗ Dokunmatik ekran algılanmadı",
  inputGamepad: "✓ Gamepad bağlı",
  inputGamepadOff: "✗ Gamepad yok",
  updateAvailable: "Yeni sürüm mevcut — yenilemek için dokun",
  madeIn: "❄️ ile Savoie'da yapıldı",
  feedback: "Geri bildirim gönder",
  on: "✓ AÇIK",
  off: "✗ KAPALI",
  zoneClosed: "🚫 BÖLGE KAPALI",

  // Settings
  language: "Dil",
  accessibility: "Erişilebilirlik",
  highContrast: "Yüksek Kontrast",
  reducedMotion: "Azaltılmış Hareket",
  showFps: "FPS göster",
  showDebug: "Hata Ayıklama",
  skiStyle: "Stil",
  skiTricks: "Hareketler",
  skiBestCombo: "En iyi kombo",
  quitGame: "Oyundan çık",
  display: "Görünüm",
  displayWindowed: "Pencere",
  displayFullscreen: "Tam Ekran",
  displayBorderless: "Kenarlıksız",
  colorblindMode: "Renk Körlüğü",
  none: "Yok",
  deuteranopia: "Deutan.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Hareket",
  moveUp: "Yukarı",
  moveDown: "Aşağı",
  moveLeft: "Sol",
  moveRight: "Sağ",
  groom: "Pist bak.",
  winch: "Vinç",
  pause: "Duraklat",
  keyboard: "Klavye",
  clickToRebind: "Değiştirmek için tıkla",
  pressKey: "Bir tuşa bas...",
  pressGamepadButton: "Gamepad düğmesine bas...",
  noGamepad: "Oyun kolu bağlı değil",
  gamepadButtons: "Gamepad",
  saved: "Kaydedildi!",
  resetControls: "Tümünü Sıfırla",
  controlsReset: "Kontroller sıfırlandı!",
  movementSensitivity: "Hassasiyet",
  keyboardLayout: "Düzen",
  customBindings: "Özel",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Dokunmatik",
  // UNUSED touchSupported: "Dokunma OK",
  noGamepadConnected: "Gamepad bağlı değil",
  gamepadDiagnostic: "Kumanda testi",
  connectGamepadDiag: "Test için bir kumanda bağla",
  gamepadDiagButtons: "Düğmeler",
  gamepadDiagSticks: "Çubuklar",
  gamepadDiagTriggers: "Tetikler",

  // Audio
  audio: "Ses",
  masterVolume: "Ana Ses",
  musicVolume: "Müzik",
  sfxVolume: "Ses Efektleri",
  engineVolume: "Motor",
  voiceVolume: "Sesler",
  ambienceVolume: "Ortam",
  mute: "Sessiz",

  backgroundAudio: "Arka plan sesi",
  // Gameplay
  bonus: "Bonus",
  skiMode: "İniş modu",
  ski: "Kayak",
  snowboard: "Snowboard",
  random: "Rastgele",
  skiIt: "Kayağa!",
  rideIt: "Kaymaya!",
  skiAgain: "Tekrar kay!",
  rideAgain: "Tekrar kay!",
  skiRunSpeed: "Hız",
  skiRunTime: "Süre",
  skiRunGates: "Kapılar",

  // How to Play hints
  howToPlayMove: "Hareket için {keys} veya ok tuşları",
  howToPlayMoveTouch: "Sanal D-pad'i kullan",
  howToPlayMoveGamepad: "Hareket için sol çubuk veya D-pad",
  howToPlayMoveHybrid: "{keys}/ok tuşları veya dokunmatik D-pad",
  howToPlayGroom: "Kar ezmek için {groomKey}",
  howToPlayGroomTouch: "Ezme düğmesini basılı tut",
  howToPlayGroomGamepad: "kar ezmek için",
  howToPlayGroomHybrid: "{groomKey} veya ezme düğmesini basılı tut",
  howToPlayFuel: "Yakıt ve dayanıklılığa dikkat!",
  howToPlayWinch: "Vinç için {winchKey} ankraj yanında",
  howToPlayWinchTouch: "Ankraj yanında vinç düğmesini basılı tut",
  howToPlayWinchGamepad: "vinç için ankraj yanında",
  howToPlayWinchHybrid: "{winchKey} veya ankraj yanında vinç düğmesini basılı tut",

  // Winch
  winchSnapped: "💥 Kablo koptu!",
  winchAttached: "🔗 Vinç bağlı! Yardım için {winchKey} basılı tut.",
  winchActive: "VİNÇ",
  // UNUSED winchHint: "Vinç kullanmak için ankraj direğinin yanında {winchKey} bas",
  // UNUSED winchHintTouch: "Vinç için 🔗 basılı tut",
  // UNUSED accessPath: "Servis Yolu",
  // UNUSED toPiste: "Piste git",

  // Taunts - Cliff falls
  tauntCliff1: "9 ton uçuruma. Sigorta bunu çok sevecek.",
  tauntCliff2: "Jean-Pierre 'kenara çok yaklaşma!' demişti. Hatırladın mı?",
  tauntCliff3: "Kurtarma ekibi halatlarla iniyor. Yine.",
  tauntCliff4: "Marie bu akşamki raclette rezervasyonunu iptal ediyor.",
  tauntCliff5: "Thierry tamir masraflarını hesaplıyor...",

  // Taunts - Fuel empty
  tauntFuel1: "Gösterge 10 dakikadır kırmızıydı. Neye bakıyordun?",
  tauntFuel2: "Émilie tahtaya büyük harflerle 'YAKIT AL' yazdı.",
  tauntFuel3: "Dizelin bile sınırları var. Senin de, görünüşe göre.",
  tauntFuel4: "Jean-Pierre iç çekiyor. Thierry'yi bidonla gönderiyor.",
  tauntFuel5: "Güneş doğuyor. Pist hazır değil. Kayakçılar geliyor.",

  // Taunts - Time limit
  tauntTime1: "İlk telesiyej 3... 2... 1... Kaçırdın.",
  tauntTime2: "Kayakçılar pistini keşfediyor. Tümsekli. Buzlu. Muhteşem.",
  tauntTime3: "Jean-Pierre saatine bakıyor, sonra sana, sonra saatine.",
  tauntTime4: "FIS slalomun neden çorba olduğunu soruyor.",
  tauntTime5: "Kayak hocalarının müşterilere neden 'onların hatası olmadığını' açıkladığını duyuyorsun.",

  // UNUSED paused: "Duraklatıldı",
  resume: "Devam Et",
  quitToMenu: "Menüye Çık",
  levelComplete: "Pist Tamamlandı!",
  levelFailed: "Pist Başarısız",
  tryAgain: "Tekrar Dene",
  coverage: "Kapsam",
  time: "Süre",
  // UNUSED rating: "Değerlendirme",
  nextLevel: "Sonraki Pist",
  // UNUSED replay: "Tekrarla",
  // UNUSED pressContinue: "Devam için boşluk tuşuna bas veya dokun",
  pauseTitle: "⏸️ Duraklatıldı",
  restart: "Yeniden Başlat",
  skipRun: "Kaymayı atla",
  newRun: "Yeni pist",
  quit: "Çık",
  menu: "Menü",
  levelSelect: "Pist Seç",
  locked: "Kapalı",
   completeToUnlock: "{name} tamamla, kilidi aç",
  // UNUSED target: "Hedef",
  tutorial: "Kayak Okulu",
  timeUsed: "Geçen Süre",
  excellent: "Mükemmel!",
  good: "Aferin!",
  passed: "Geçti",
  bonusFuel: "Yakıt kullanımı",
  bonusFlawless: "İlk denemede",
  bonusSpeed: "Süre",
  bonusWinch: "Vinç kullanımı",
  bonusExplore: "Keşfedilen yollar",
  bonusPrecision: "Hazırlama kalitesi",
  retry: "Yeniden Dene",
  gameComplete: "Oyun Tamamlandı!",
  viewCredits: "Jenerikleri Gör",
  creditsTitle: "Tebrikler!",
  creditsSubtitle: "Les Aiguilles Blanches'ta ustalaştın",
  creditsCreatedBy: "Yapımcı",
  creditsDevelopedWith: "Geliştirme aracı",
  creditsArtDirection: "Sanat Yönetimi",
  creditsRetroInspiration: "SkiFree gibi retro klasiklere selam",
  creditsInspiredBy: "İlham kaynağı",
  creditsGroomers: "Savoie'nin pist bakımcıları",
  creditsDedication: "Biz uyurken pistleri hazırlayan gece ekiplerine",
  creditsThanks: "Oynadığın için teşekkürler!",
  creditsSeeYou: "Pistlerde görüşürüz!",
  creditsLine: "Hadi, evlat. Güneş doğuyor. Dağ hazır.",
  playAgain: "Tekrar Oyna",
  skipCredits: "Atlamak için bir tuşa bas",

  // Tutorial
  tutorialName: "Öğretici - İlk Adımlar",
  tutorialTask: "Pist bakım temellerini öğren",
  prologueLine: "Saat 4. Dağ senin. İş başına.",
  prologueSkip: "Devam için bas",
  tutorialIntro: "Les Aiguilles Blanches'a hoş geldin!",
  skipTutorial: "⏭️ Öğretici atlanıyor… Tekrar için dokun.",
  skipTutorialGamepad: "⏭️ Öğretici atlanıyor… Tekrar için düğmeye bas.",
  tutorialWelcome: "🏔️ Jean-Pierre, baş pistçi. Pistte dolaş — {keys} veya ↑↓←→ kullan.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, baş pistçi. Pistte dolaş — soldaki D-pad'i kullan.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, baş pistçi. Pistte dolaş — sol çubuk veya D-pad kullan.",
  // UNUSED     tutorialControls: "🎮 Kar ezme aracını hareket ettirmek için {keys} veya ok tuşlarını ↑↓←→ kullan.",
  // UNUSED     tutorialControlsTouch: "🎮 Kar ezme aracını hareket ettirmek için soldaki D-pad'i ◀▲▼▶ kullan.",
  // UNUSED     tutorialControlsGamepad: "🎮 Kar ezme aracını hareket ettirmek için sol çubuk veya D-pad kullan.",
  // UNUSED     tutorialMove: "➡️ Haydi, dene! Pistte hareket et — tüm beyaz kar bakıma ihtiyaç duyuyor.",
  // UNUSED     tutorialGroomIntro: "✅ Güzel! Şimdi pist bakımını öğrenelim.",
  tutorialGroomAction: "❄️ Sürerken {groomKey} basılı tutarak karı ez. Düzleşecek.",
  tutorialGroomActionTouch: "❄️ Sürerken sağdaki ezme düğmesini basılı tut.",
  tutorialGroomActionGamepad: "❄️ Sürerken {groomKey} basılı tutarak karı ez. Düzleşecek.",
  tutorialGroomGoal: "📊 İşte böyle! Açılıştan önce en az %60'ını ez. Kayakçılar geliyor!",
  // UNUSED   tutorialCoverage: "📊 Gördün mü? Kar daha pürüzsüz! Pisti ezmeye devam et.",
  // UNUSED   tutorialHUD: "📈 Üstteki paneli kontrol et: kırmızı yakıt, yeşil dayanıklılık, beyaz kapsam. Zaman akıyor!",
  // UNUSED   tutorialGoal: "🎯 Açılıştan önce pistin en az %60'ını ezmelisin. Kayakçılar geliyor!",
  // UNUSED tutorialFuel: "⛽ Dikkat — sürüş yakıt tüketir. Görevlerde yakıt istasyonuna uğra.",
  tutorialComplete: "🏆 Aferin! Temelleri öğrendin. Yeşil pistteki ilk görevine hazır mısın?",

  level_marmottesName: "Yeşil Pist - Les Marmottes",
  level_marmottesTask: "Başlangıç pistini hazırla",
  level_chamoisName: "Mavi Pist - Le Chamois",
  level_chamoisTask: "Açılıştan önce verimli çalış",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Freestyle elemanlarını hazırla",
  level_aigleName: "Kırmızı Pist - L'Aigle",
  level_aigleTask: "Dik arazide çalış, yakıta dikkat",
  level_glacierName: "Kırmızı Pist - Le Glacier",
  level_glacierTask: "Dik yamaçlarda vinç kullanmayı öğren",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Yarışma için half-pipe bakımını yap",
  level_verticaleName: "Siyah Pist - La Verticale",
  level_verticaleTask: "Vinçli gece operasyonu",
  level_colDangereuxName: "Çığ Bölgesi - Col Dangereux",
  level_colDangereuxTask: "Yüksek riskli bölgeyi hazırla",
  level_tempeteName: "Fırtına - Kurtarma",
  level_tempeteTask: "Fırtınadan sonra pistleri temizle",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - FIS Finali",
  level_coupeDesAiguillesTask: "Tüm pistleri yarışma için hazırla",

  // Hazards
  cliffFall: "⚠️ DİKKAT! Uçurumdan düştün! Görev başarısız.",
  fuelEmpty: "⛽ YAKIT BİTTİ! Bir damla dizel kalmadı...",
  // UNUSED avalancheZone: "ÇIĞ BÖLGESİ",
  riskLevelHigh: "YÜKSEK",
  avalancheWarning: "⚠️ TEHLİKE! Kar örtüsü dengesiz! Bölgeden çık!",
  avalancheTrigger: "🏔️💨 ÇIĞ TETİKLENDİ! Kaçış yok!",
  steepWarning: "⚠️ DİK YAMAÇ! Vinç kullan ({winchKey}) yoksa kayarsın!",
  steepWarningNoWinch: "⚠️ DİK YAMAÇ! Yavaşla ve servis yollarını kullanarak dolan!",
  tumble: "🔄 DEVRİLME! Araç yamaçta devrildi!",

  // Taunts - Tumble
  tauntTumble1: "Vinç süs için değil. Böyle yamaçlar için.",
  tauntTumble2: "Thierry hasara bakıyor. Hiçbir şey söylemiyor. Bu daha kötü.",
  tauntTumble3: "Jean-Pierre nasıl bağlanacağını gösterdi. Uyuyor muydun?",
  tauntTumble4: "Bir PistenBully 400.000 € eder. Ederdi, demek lazım.",
  tauntTumble5: "Yamaç idare edilir miydi? Araç aynı fikirde değildi.",
  featureDestroyedKicker: 'Park elemanının üzerinden geçtin! Kicker harap oldu.',
  featureDestroyedRail: 'Park elemanının üzerinden geçtin! Rail harap oldu.',
  tauntFeature1: 'O elemanı yapmak üç saat sürdü. Sen üç saniyede düzledin.',
  tauntFeature2: 'Émilie o park elemanı hakkında seninle konuşacak.',
  tauntFeature3: 'Park ekibi başyapıtlarını yıktığını izledi.',
  tauntFeature4: 'Elemanlar kayakçılar için, kar eziciler için değil. Etrafından dön!',
  tauntFeature5: 'Yarınki yarışma için bir eleman eksildi.',
  bonusPipeMastery: 'Halfpipe ustalığı',

  // Taunts - Avalanche
  tauntAvalanche1: "Dağ nadiren affeder. Bu sefer affetmedi.",
  tauntAvalanche2: "Météo France risk seviyesi 4 dedi. Okudun mu?",
  tauntAvalanche3: "Kurtarma ekibi aracı baharda bulur. Belki.",
  tauntAvalanche4: "Marie telsiz alarmını duyuyor. Senin olduğunu zaten biliyor.",
  tauntAvalanche5: "Kurtarma ekibi o sektörü güvence altına almıştı. Sen güvensizleştirdin.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Klasik takla. Malzeme her yerde, gurur hiçbir yerde.",
  tauntSkiWipeout2: "Uçurumun kayak tekniğinle ilgilenmedi.",
  tauntSkiWipeout3: "Kurtarma ekibi zaten gülüyor. Her şeyi gördüler.",
  tauntSkiWipeout4: "Kendi hazırladığın pistte kayarsan böyle olur.",
  tauntSkiWipeout5: "Dağ keçileri bile o inişe yüzlerini buruşturdu.",

  jeanPierreIntro: "Eğitimde iyi iş çıkardın. Şimdi gerçek başlıyor — yeşil pist, süre ve yakıt yönetimiyle.",
  level_marmottesMid: "Zirvelerdeki o ışığı görüyor musun? İlk aydınlık. Bu işin en güzel yanı — sadece sen, makine ve uyanan dağ.",
  level_chamoisIntro: "Selam, ben Émilie — JP seni mavi piste gönderiyor. Sadece yeşilde kadife döşemekten fazlasını yapabildiğini göster.",
  level_airZoneIntro: "Snowpark BENİM alanım — müthiş bir parkur hazırlayacağız! Her modül mükemmel olmalı, sporcular bize güveniyor.",
  level_aigleIntro: "L'Aigle ciddi iş. Yakıta dikkat et. Servis yollarıyla geri çıkabilirsin — sarı-siyah direkleri ara.",
  level_glacierIntro: "Selam, ben Thierry — güvenlik sorumlusu. Le Glacier dik. Her ankrajı kontrol ettim. Vinç bağlamak için direğin yanında {winchKey} bas — ve lütfen, bırakma.",
  level_glacierIntroTouch: "Selam, ben Thierry — güvenlik sorumlusu. Le Glacier dik. Her ankrajı kontrol ettim. Direğin yanında vinç düğmesine dokun — ve lütfen, bırakma.",
  level_tubeIntro: "Yarın Tube'da yarışma! Temiz duvarlar, keskin dudak ve sıfır çıkıntı istiyorum.",
  level_verticaleIntro: "La Verticale'de gece operasyonu: dik yamaç, tehlikeli kenarlar. Vinç zorunlu — 3 ankrajı kullan ve hattan sapma.",
  level_colDangereuxIntro: "Geçitte yüksek çığ riski — Çığ güvenlik protokolü aktif. Yüklü alanlardan uzak dur ve sınırlara uy.",
  level_tempeteIntro: "Fırtına geçti. Bir vin chaud al — bu biraz sürecek!",
  level_coupeDesAiguillesIntro: "Bu büyük gece. FIS yarın kontrol ediyor. Her pist mükemmel olmalı — öğrendiklerini göster.",
  marieWelcome: "Chez Marie'de ısınmaya gel. Güzel bir tartiflette!",
  marieIntro: "Merhaba! Ben Marie, pistin üstündeki restoranı işletiyorum. İstediğin zaman uğra — sıcak yemek burada mucize yapar!",

  // Changelog
  changelog_20260219_date: "19 Şubat 2026",
  changelog_20260219: "🎬 Yeni oyuncular için prolog\n📖 Basitleştirilmiş eğitim\n🌦️ Menüde rastgele hava\n🔗 Paylaşılabilir günlük parkurlar\n🎥 Sinematik jenerik",
  changelog_20260222_date: "22 Şubat 2026",
  changelog_20260222: "🚩 Slalom kapısı dengelemesi\n💬 Geri bildirim düğmesi",
  changelog_20260223_date: "23 Şubat 2026",
  changelog_20260223: "📲 Cihazına yükle, internetsiz oyna",
  changelog_20260220_date: "20 Şubat 2026",
  changelog_20260220: "🗺️ Pist haritası\n🎿 Kayak merkezi terminolojisi",
  changelog_20260217_date: "17 Şubat 2026",
  changelog_20260217: "🏔️ Yedi pist şekli\n🎯 Pist çeşitliliği\n⚡ Akıcı kayak deneyimi",
  changelog_20260216_date: "16 Şubat 2026",
  changelog_20260216: "🎲 Günün Pistleri",
  changelog_20260215_date: "15 Şubat 2026",
  changelog_20260215: "⚡ Gece görüntüleme yenilendi\n📱 Kayak modu dokunmatik düğmeler\n⌨️ Klavye düzeni algılama",
  changelog_20260214_date: "14 Şubat 2026",
  changelog_20260214: "🎪 Trick puanlama & kombolar\n🏂 Hız pozisyonu & halfpipe fiziği\n👁️ Daha iyi pist kontrastı\n📱 Vinçle otomatik ezme (dokunmatik)\n♿ Yüksek kontrast modu",
  changelog_20260213_date: "13 Şubat 2026",
  changelog_20260213: "🚩 Slalom kapıları\n🏔️ Kayak atlayışları\n⚡ Geliştirilmiş performans\n🎹 Nokturne piyano müziği\n🔊 Motor sesi ayarlanabilir",
  changelog_20260212_date: "12 Şubat 2026",
  changelog_20260212: "📋 Pist haritası\n🔗 Kırılabilir vinç kablosu\n🕹️ Kumanda teşhisi\n🍽️ Marie'nin yemekleri\n❄️ Soğuk maruziyeti",
  changelog_20260211_date: "11 Şubat 2026",
changelog_20260211: "⛷️ Hazırlama sonrası kayak inişi\n🎯 Hazırlama kalitesi\n🏔️ Renk kodlu dik bölgeler\n🏗️ Park ve trick'ler",
  changelog_20260210_date: "10 Şubat 2026",
  changelog_20260210: "🎵 Müzik ve ses efektleri\n🔈 Ses ayarları\n⏱️ Otomatik kalibreli pist süreleri\n⏭️ Eğitimi atla\n🏔️ Çığ bölgeleri yeniden tasarlandı",
  changelog_20260209_date: "9 Şubat 2026",
  changelog_20260209: "🏔️ Alp kazanma/kaybetme ekranları\n❄️ Fırtınada kar birikimi\n🏆 Kusursuz bonusu\n🔊 Hava ve doğa sesleri",
  changelog_20260208_date: "8 Şubat 2026",
  changelog_20260208: "📊 Yeniden tasarlanan panel\n🏔️ Le Glacier ve Coupe des Aiguilles\n🦅 Alp yaban hayatı\n🎨 Karakter portreleri\n🎮 Klavye ve gamepad navigasyonu",
  changelog_20260207_date: "7 Şubat 2026",
  changelog_20260207: "🎨 Retro arayüz\n🎯 Bonus hedefler\n🕹️ Gamepad düğme atama\n🎮 Menüde gamepad navigasyonu",
  changelog_20260206_date: "6 Şubat 2026",
  changelog_20260206: "🛤️ Geçilebilir servis yolları\n🕹️ Sanal joystick\n🌍 5 dil desteği",
  changelog_20260205_date: "5 Şubat 2026",
  changelog_20260205: "🏔️ Kayalık uçurumlar\n🌙 Gece farları\n🔗 Vinç mekaniği\n⌨️ Klavye navigasyonu",
  changelog_20260204_date: "4 Şubat 2026",
  changelog_20260204: "🎮 Gamepad desteği\n📱 Dokunmatik kontrol\n💪 Dayanıklılık\n💾 İlerleme kaydetme\n♿ Erişilebilirlik",
  changelog_20260203_date: "3 Şubat 2026",
  changelog_20260203: "🚜 Lansman: 9 pist, kayak okulu\n❄️ Pist bakımı, yakıt, çığlar\n🏆 Jenerik ve ilerleme",
  // Key names
  key_space: "BOŞLUK",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "SİL",
  dailyRuns: "Günün Pistleri",
  dailyRuns_dailyShift: "Günlük Vardiya",
  dailyRuns_randomRun: "Rastgele Sürüş",
  dailyRuns_rank: "Sıralama",
  dailyRuns_seed: "Tohum",
  // UNUSED   dailyRuns_start: "Sözleşmeyi Başlat",
  dailyRuns_locked: "Kilidini açmak için tüm pistleri tamamlayın",
  dailyRuns_lockedShared: "Tüm pistleri tamamlayarak Günlük Turları açın ve bu paylaşılan pisti oynayın",
  // UNUSED   dailyRun_levelName: "Sözleşme",
  dailyRun_levelTask: "Pisti hedef kaplama oranına kadar hazırlayın",
  dailyRuns_briefing: "Brifing",
  dailyRuns_target: "Hedef",
  dailyRuns_timeLimit: "Süre",
  dailyRuns_weather_clear: "Açık hava",
  dailyRuns_weather_light_snow: "Hafif kar yağışı",
  dailyRuns_weather_storm: "Fırtına koşulları",
  dailyRuns_night: "Gece vardiyası",
  dailyRuns_day: "Gündüz vardiyası",
  rank_green: "Yeşil",
  rank_blue: "Mavi",
  rank_red: "Kırmızı",
  rank_black: "Siyah",
  rank_park: "Park",
  share: "Paylaş",
  copied: "Bağlantı kopyalandı!",
  playSharedSeed: "Paylaşılan tur",
  dailyRunBriefingJP: "Pist, liftler açılmadan hazır olmalı. Hadi başla.",
  dailyRunBriefingThierry: "Dikkat et orada — dik geçişler ve kararsız kar var. Tetikte ol.",
  dailyRunBriefingMarie: "Bu gece çok soğuk olacak. İhtiyacın olursa restorana gel, ısın biraz.",
  dailyRunBriefingEmilie: "Bir pist daha. Bakalım süreme yetişebilecek misin!"
};

export default tr;
